import { router } from '@/router';
import { PageEnum } from '@/enums/pageEnum';
import { RouteLocationNormalizedLoaded } from 'vue-router';
import type { SysType } from '#/sys';
import { H5SendPv } from './tracker';

export function navigateBack(delta = -1) {
    router.go(delta);
}

export function redirectTo({ name, data, replace = false }: SysType.urlType) {
    const packet = pack(data);
    if (data) {
        name
            ? router.replace({ name, query: { packet }, replace })
            : router.replace({ query: { packet }, replace });
    } else {
        router.replace({ name });
    }
    H5SendPv(name);
}

export function navigateTo({ name, data, replace = false }: SysType.urlType) {
    const packet = pack(data);
    if (data) {
        name
            ? router.push({ name, query: { packet }, replace })
            : router.push({ query: { packet }, replace });
    } else {
        router.push({ name });
    }
    H5SendPv(name);
}

export function getQuery(route: RouteLocationNormalizedLoaded) {
    return unpack(route.query.packet);
}

export function pack(data) {
    return encodeURIComponent(JSON.stringify(data));
}

export function unpack(string) {
    return string ? JSON.parse(decodeURIComponent(string)) : {};
}

export function updateTitle(pageName: PageEnum, newTitle: string) {
    if (!pageName) {
        return;
    }

    const current = router.getRoutes().find((item) => item.name === pageName)!;
    current.meta.title = newTitle;
}
